var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{staticClass:"border-black h-32",attrs:{"size":"sm","options":_vm.typesList},model:{value:(_vm.type.search),callback:function ($$v) {_vm.$set(_vm.type, "search", $$v)},expression:"type.search"}})}
var staticRenderFns = []

export { render, staticRenderFns }